import { Theme } from "@mui/material";

export const menuComponentStyles = {};

const menuItemTouchCompact = (theme: Theme) =>
  ({
    [theme.breakpoints.down("md")]: {
      py: "8px",
      px: "12px",
      pr: "26px",
      fontSize: "12.75px",
      lineHeight: 1.32,
      minHeight: "auto",
    },
    [theme.breakpoints.down("sm")]: {
      py: "7px",
      px: "10px",
      pr: "22px",
      fontSize: "12px",
      lineHeight: 1.28,
      minHeight: "auto",
    },
  }) as const;

export const copyLinkMenuItemStyles = (theme: Theme) => ({
  py: "16px",
  pl: "16px",
  pr: "32px",
  backgroundColor: theme.palette.messageMenuDropdown.bg,
  borderTopRightRadius: "18px",
  borderTopLeftRadius: "18px",
  fontSize: "14px",
  fontWeight: 500,
  "&:hover": {
    backgroundColor: theme.palette.messageMenuDropdown.bg,
    color: "#06B6D4",
  },
  ...menuItemTouchCompact(theme),
});

export const menuItemStyles = (theme: Theme) => ({
  px: "16px",
  py: "16px",
  fontSize: "14px",
  fontWeight: 500,
  backgroundColor: theme.palette.messageMenuDropdown.bg,
  "&:hover": {
    backgroundColor: theme.palette.messageMenuDropdown.bg,
    color: "#06B6D4",
  },
  ...menuItemTouchCompact(theme),
});

export const deleteMenuItemStyles = (theme: Theme) => ({
  py: "16px",
  pl: "16px",
  pr: "32px",
  backgroundColor: theme.palette.messageMenuDropdown.bg,
  borderBottomRightRadius: "18px",
  borderBottomLeftRadius: "18px",
  color: "#DD503E",
  fontSize: "14px",
  fontWeight: 500,
  "&:hover": {
    backgroundColor: theme.palette.messageMenuDropdown.bg,
    color: "#06B6D4",
  },
  ...menuItemTouchCompact(theme),
});
